import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ArrowUpRight } from "lucide-react";
import { BUILD_REFUND_PERCENT } from "@/lib/commercial-terms";
import "./FinalSections.css";

const faqs = [
  {
    q: "How does the investment work?",
    a: `Build once from $27,000. Then commission only until we hit your agreed cash target. Miss it and ${BUILD_REFUND_PERCENT}% of your build payment comes back. After proof, a monthly team is optional, from $27,000 plus commission.`,
  },
  {
    q: "What counts as proof?",
    a: "Cash collected from customers we bring in. For example, $80k from new customers. We agree your target upfront based on deal size, margins and payment terms, then use a smaller team to prove we can reach it.",
  },
  {
    q: "What do you actually do?",
    a: "We find buyers, book meetings and close deals. We also run the content, follow-up, CRM and sales management behind it. You get a sales team without recruiting and managing every role yourself.",
  },
  {
    q: "What if we already have a sales team?",
    a: "Keep your team and CRM. We take on prospecting, follow-up and admin so your reps spend more time closing. We agree who owns each deal so buyers don't get lost between teams.",
  },
  {
    q: "Do you write our positioning and copy?",
    a: "Yes. We write your content and sales messages so buyers quickly understand what you solve and why it's worth paying for.",
  },
  {
    q: "Who runs our sales?",
    a: "We recruit, train and manage your GTM team: salespeople to book and close, managers to coach them, and AI operators to handle research and admin.",
  },
  {
    q: "What channels do you use?",
    a: "Email, phone, LinkedIn, newsletters, guides and personal mail. We choose the mix for your buyers and follow up on the interest it creates.",
  },
  {
    q: "Do we have to change our CRM?",
    a: "No. We use your CRM or set one up if you need it. Contacts, conversations and next steps stay together, so reps enter each call prepared.",
  },
  {
    q: "How fast can you start?",
    a: "Within two weeks of kickoff: your buyers identified, campaigns live and salespeople ready to sell.",
  },
  {
    q: "Which businesses do you work with?",
    a: "B2B software, technology and specialist services companies doing $1M+ a year. You have a proven offer, but need more sales than your current team can deliver, or still have to drive every deal yourself.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" className="faq-editorial bg-paper" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
        <div className="faq-intro lg:col-span-4">
          <h2 className="font-display font-semibold tracking-[-0.02em] text-4xl md:text-6xl leading-[0.92] text-ink text-balance">
            Straight <span className="font-editorial italic font-medium text-cobalt">answers.</span>
          </h2>
          <a href="#contact" className="faq-contact-link">Have another question? <ArrowUpRight size={22} aria-hidden="true" /></a>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full border-t border-ink">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="faq-question border-b border-ink" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="faq-trigger text-left font-display font-medium hover:no-underline">
                  <span>{f.q}</span>
                  <span className="faq-symbol" aria-hidden="true" />
                </AccordionTrigger>
                <AccordionContent className="faq-answer font-light leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
